// Application role taxonomy — mirrors the backend (backend/src/modules/auth/roles.js).
// The authenticated user's `role` is one of these keys; UI gating and the
// RoleRoute guard compare against them.

export const ROLES = Object.freeze({
  OPERATOR_ADMIN: 'operator_admin',
  REGIONAL_ADMIN: 'regional_admin',
  FINANCE_USER: 'finance_user',
  MERCHANT_USER: 'merchant_user',
  WAREHOUSE_OPERATOR: 'warehouse_operator',
  CROSS_BORDER_OPS: 'cross_border_ops',
});

export const ROLE_LABELS = Object.freeze({
  [ROLES.OPERATOR_ADMIN]: 'Operator Admin',
  [ROLES.REGIONAL_ADMIN]: 'Regional Admin',
  [ROLES.FINANCE_USER]: 'Finance User',
  [ROLES.MERCHANT_USER]: 'Merchant User',
  [ROLES.WAREHOUSE_OPERATOR]: 'Warehouse Operator',
  [ROLES.CROSS_BORDER_OPS]: 'Cross-Border Operations User',
});

export const CROSS_TENANT_ROLES = Object.freeze([ROLES.OPERATOR_ADMIN, ROLES.REGIONAL_ADMIN]);

export const roleLabel = (role) => ROLE_LABELS[role] || role || 'Unknown';

export default ROLES;
